import './assets/styles/tlmstrap.css';
import 'react-toastify/dist/ReactToastify.css';
import 'animate.css/animate.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {AuthProvider} from "./services/firebase/AuthProvider";
import {ClientProvider} from "./providers/ClientProvider";

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <ClientProvider>
        <App/>
      </ClientProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
